import { unitWiseEmployee } from "@api/e-tickets/unitWiseEmployee";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { useEffect, useState } from "react";

export const useUnitWiseEmployee = () => {
  const [query, setQuery] = useState({
    unitId: undefined,
    officeId: undefined,
    positionId: undefined,
  });
  const [employees, setEmployees] = useState<EmployeeCommonInfoType[] | []>([]);

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    if (query?.officeId || query?.unitId || query?.positionId) {
      unitWiseEmployee(query)
        .then((data) => {
          setEmployees(data);
        })
        .catch((error) => {
          setEmployees([]);
        });
    }
  }, [query]);

  return {
    employees,
    handleQuery,
  };
};
